import { useState } from 'react';
import type { CartLine } from '@/api/models';
import { useCartActions } from './useCart';
import { useUI } from '@/context/UIContext';

/** Quantity and remove actions for one cart line, shared by the drawer and the bag page. */
export function useLineActions(line: CartLine) {
  const { update, remove } = useCartActions();
  const { showToast } = useUI();
  const [busy, setBusy] = useState(false);

  const run = async (fn: () => Promise<unknown>) => {
    setBusy(true);
    try { await fn(); }
    catch (e) { showToast((e as Error).message, { tone: 'error' }); }
    finally { setBusy(false); }
  };

  return {
    busy,
    canIncrease: line.quantity < line.maxQuantity,
    increase: () => run(() => update.mutateAsync({ key: line.key, quantity: line.quantity + 1 })),
    decrease: () => run(() => line.quantity <= 1
      ? remove.mutateAsync(line.key)
      : update.mutateAsync({ key: line.key, quantity: line.quantity - 1 })),
    remove: () => run(() => remove.mutateAsync(line.key)),
  };
}
